import * as m from "@paraglide/messages"
import { PlaydataButtonLink, PlaydataSection } from "@playdata/PlaydataPrimitives"
import type { SupportedLocale } from "@site-types/content"
import { createFileRoute } from "@tanstack/react-router"
import { playdataRouteHead } from "@utils/playdata-route-head"

export const Route = createFileRoute("/$locale/playdata/thanks")({
  head: ({ params }) => {
    const locale = params.locale as SupportedLocale
    return playdataRouteHead({
      description: m.playdata_thanks_meta_description({}, { locale }),
      locale,
      path: "/playdata/thanks",
      robots: "noindex",
      title: m.playdata_thanks_meta_title({}, { locale }),
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: raw } = Route.useParams()
  const locale = raw as SupportedLocale
  return (
    <PlaydataSection className="py-[10rem]">
      <div className="flex flex-col items-center gap-[2.4rem] text-center">
        <h1 className="text-[2.8rem] md:text-[3.4rem]">
          <strong>{m.playdata_thanks_heading({}, { locale })}</strong>
        </h1>
        <p className="text-[1.6rem]">{m.playdata_thanks_body({}, { locale })}</p>
        <PlaydataButtonLink
          params={{ locale }}
          to="/$locale/playdata"
        >
          {m.playdata_thanks_cta({}, { locale })}
        </PlaydataButtonLink>
      </div>
    </PlaydataSection>
  )
}
